import { useWeb3React } from '@web3-react/core';
import { BigNumber, Contract, ethers, Signer } from 'ethers';
import {
  ChangeEvent,
  MouseEvent,
  ReactElement,
  useEffect,
  useState
} from 'react';
import { SignMessage } from './SignMessage';
import styled from 'styled-components';
import { Provider } from '../utils/provider';
import { SectionDivider } from './SectionDivider';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';

import { 
  getFromURI
} from './IpfsApp';

//Contract OG
//import NFTArtifact from '../artifacts/contracts/NFT.sol/NFT.json';
//import NFTAddress from '../artifacts/contracts/NFT.sol/NFT-address.json';
/*
//Contract ALPHA TEST
import NFTArtifact from '../artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT.json';
import NFTAddress from '../artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT-address.json';
*/

//Contract LIVE
import NFTArtifact from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT.json';
import NFTAddress from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT-address.json';

//Contract LIVE
import OGNFTArtifact from '../live_artifacts/contracts/OGNFT.sol/OGNFT.json';
import OGNFTAddress from '../live_artifacts/contracts/OGNFT.sol/OGNFT-address.json';

//BITCORE LIVE
import BitcoreNFTArtifact from '../live_artifacts/contracts/BitcoreNFT.sol/BitcoreNFT.json';
import BitcoreNFTAddress from '../live_artifacts/contracts/BitcoreNFT.sol/BitcoreNFT-address.json';

//PLATECORE LIVE
import PlatecoreNFTArtifact from '../live_artifacts/contracts/PlatecoreNFT.sol/PlatecoreNFT.json';
import PlatecoreNFTAddress from '../live_artifacts/contracts/PlatecoreNFT.sol/PlatecoreNFT-address.json';


const StyledGreetingDiv = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 135px 2.7fr 1fr;
  grid-gap: 10px;
  place-self: center;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-weight: bold;
`;



const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;


export function PlateFuseApp(): ReactElement {
  return (
    <StyledAppDiv>
      <NFTMarketplaceContract />
    </StyledAppDiv>
  );
}

export function NFTMarketplaceContract(): ReactElement {
  const context = useWeb3React<Provider>();
  const { library } = context;

  const [signer, setSigner] = useState<Signer>();
  const [items, setItems] = useState<any[]>([]);
  const [fuseItems, setFuseItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const account = context.account;
 
  const [totalSelected, setTotalSelected] = useState(0);
  const [newFuseCoreColour, setnewFuseCoreColour] = useState(0);
  const [newFuseCoreColourCode, setnewFuseCoreColourCode] = useState(0);
  const [newFuseCoreColourText, setnewFuseCoreColourText] = useState('');

  const [fusePLATECOREButton, setFusePLATECOREButton] = useState<string>('SELECT 4 BITCOREs TO FUSE $PLATECORE NFT');


  useEffect((): void => {
    if (!library) {
      setSigner(undefined);
      return;
    }

    setSigner(library.getSigner());
  }, [library]);

  //test for account change
  useEffect(() => {
    setLoading(true);
    handleAttachContract();
  }, [account]);

  //Because state update is asynchronous we must listen for signer to be updated
  useEffect(() => {
    handleAttachContract();
  }, [signer]);

  function handleAttachContract() {

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

   // window.alert("do change");


    async function attachNFTContract(signer: Signer): Promise<void> {
      
      const NFT = new ethers.ContractFactory(
        NFTArtifact.abi,
        NFTArtifact.bytecode,
        signer
      );

      const OGNFT = new ethers.ContractFactory(
        OGNFTArtifact.abi,
        OGNFTArtifact.bytecode,
        signer
      );

      const BITCORENFT = new ethers.ContractFactory(
        BitcoreNFTArtifact.abi,
        BitcoreNFTArtifact.bytecode,
        signer
      );

      
    
      try {

        const BITCOREnft = await BITCORENFT.attach(BitcoreNFTAddress.address);


        let listItems = [];

        const balanceBITCORENFT = await BITCOREnft.balanceOf(account);

        for(let i =0; i < balanceBITCORENFT; i++){
          const tokenId = await BITCOREnft.tokenOfOwnerByIndex(account,i);
          var uri = await BITCOREnft.tokenURI(tokenId);
         
          const colour = await BITCOREnft.getCore(tokenId);

          const metadata = getFromURI(uri);

        const itemId = (tokenId).toString();
        const colourBC = (colour).toString();
        const itemSelected = '0';

        let item = {
        //  itemIdHex: itemIdHex,
          itemId: itemId,
        //  price: metadata.price,
        //  name: metadata.name,
          description: metadata.description,
        //  ticker: metadata.ticker,
          image: metadata.image,
          colour: colourBC,
          selected: itemSelected
        }
        listItems.push(item);
 
        }

        setItems(listItems);
        setLoading(false);

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    attachNFTContract(signer);
  }

  function handleFusePlatecoreNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    //no valid fuse colours selected
    if (newFuseCoreColour == 0) {
      window.alert("SELECT 4 VALID BITCOREs to FUSE into a $PLATECORE");
      return;
    }

    //no valid fuse colours selected
    if (newFuseCoreColourCode == 0) {
      window.alert("SELECT 4 VALID BITCOREs to FUSE into a $PLATECORE");
      return;
    }

    if (fuseItems.length != 4) {
      window.alert("SELECT 4 VALID BITCOREs to FUSE into a $PLATECORE");
      return;
    }

    async function fuseNFT(signer: Signer): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        PlatecoreNFTArtifact.abi,
        PlatecoreNFTArtifact.bytecode,
        signer
      );

      const BITCORENFT = new ethers.ContractFactory(
        BitcoreNFTArtifact.abi,
        BitcoreNFTArtifact.bytecode,
        signer
      );


      try {

        const PLATEnftContract = await NFT.attach(PlatecoreNFTAddress.address);

        const BITCOREnft = await BITCORENFT.attach(BitcoreNFTAddress.address);
       
        const colourCode = newFuseCoreColourCode; //saved colour code
        const tokenId1 = Number(fuseItems[0].itemId);
        const tokenId2 = Number(fuseItems[1].itemId);
        const tokenId3 = Number(fuseItems[2].itemId);
        const tokenId4 = Number(fuseItems[3].itemId);

       const isApproved = await BITCOREnft.isApprovedForAll(account, PlatecoreNFTAddress.address);

       if (!isApproved) {
          await(await BITCOREnft.setApprovalForAll(PlatecoreNFTAddress.address, true)).wait();
          window.alert(`APPROVED BITCOREs`);
       }

   //     await BITCOREnft.approveFuse(PlatecoreNFTAddress.address, tokenId1, tokenId2, tokenId3, tokenId4);  

        // mint nft set gas limit high
        await(await PLATEnftContract.fuseCore(colourCode, tokenId1, tokenId2, tokenId3, tokenId4)).wait();

        // get tokenId of new nft 
        //const id = await nftContract.tokenCount();

        const totalSupply = await PLATEnftContract.totalSupply();

        window.alert(`FUSED ${newFuseCoreColourText} PLATECORE NFT ID: #${totalSupply}`);

        setnewFuseCoreColour(0);
        setTotalSelected(0);
        setnewFuseCoreColourCode(0);
        setnewFuseCoreColourText('');
        setFusePLATECOREButton('SELECT 4 BITCOREs TO FUSE $PLATECORE NFT');
        setFuseItems([]);

        //reload page
        setLoading(true);
        handleAttachContract();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    fuseNFT(signer);
  }

  function handleSelectChange(e: any, _item: any): void {

    var newTotalSelected=totalSelected;

    setTotalSelected(totalSelected+1);

    if (Number(_item.selected)) {
      _item.selected = '0';
      newTotalSelected--;
      var index = fuseItems.indexOf(_item);
      fuseItems.splice(index,1);

    } else {
      if (newTotalSelected == 4){
        //Already 4 selected
        e.target.checked = false;
        window.alert("SELECT MAX 4 BITCOREs to FUSE into a $PLATECORE");
      } else {
        _item.selected = '1';
        newTotalSelected++;
        fuseItems.push(_item);
      }
    }

    /*
        COLOUR MAP PLATECORE

        RED=1 GREEN=2 BLUE=4 CYAN=8 MAGENTA=16 YELLOW=32

        COMBINED 2 x 2
        4 RED
        6 YELLOW
        8 GREEN
        10 MAGENTA
        12 CYAN
        16 BLUE
        32 CYAN
        48 BLUE
        64 MAGENTA
        80 GREEN
        96 RED
        128 YELLOW
    */

    if (newTotalSelected == 4) {
      //Test if valid colour
      const newColour =  Number(fuseItems[0].colour) + Number(fuseItems[1].colour) + Number(fuseItems[2].colour)+ Number(fuseItems[3].colour);
      var newCoreColour = 0;
      var newFuseColour = "";
      //Select correct URI for colour
      if (newColour == 4 || newColour == 96) {
        //RED
        newCoreColour = 1;
        window.alert("Your 4 selected BITCOREs will FUSE into a RED $PLATECORE - CLICK 'FUSE RED $PLATECORE NFT'");
        newFuseColour = "RED";
      } else if  (newColour == 8 || newColour == 80) {
        //GREEN
        newCoreColour = 2;
        window.alert("Your 4 selected BITCOREs will FUSE into a GREEN $PLATECORE - CLICK 'FUSE GREEN $PLATECORE NFT'");
        newFuseColour = "GREEN";
      } else if  (newColour == 16 || newColour == 48) {
        //BLUE
        newCoreColour = 4;
        window.alert("Your 4 selected BITCOREs will FUSE into a BLUE $PLATECORE - CLICK 'FUSE BLUE $PLATECORE NFT'");
        newFuseColour = "BLUE";
      } else if  (newColour == 32 || newColour == 12) {
        //CYAN
        newCoreColour = 8;
        window.alert("Your 4 selected BITCOREs will FUSE into a CYAN $PLATECORE - CLICK 'FUSE CYAN $PLATECORE NFT'");
        newFuseColour = "CYAN";
      } else if  (newColour == 64 || newColour == 10) {
        //MAGENTA
        newCoreColour = 16;
        window.alert("Your 4 selected BITCOREs will FUSE into a MAGENTA $PLATECORE - CLICK 'FUSE MAGENTA $PLATECORE NFT'");
        newFuseColour = "MAGENTA";
      } else if (newColour == 128 || newColour == 6) {
        //YELLOW
        newCoreColour = 32;
        window.alert("Your 4 selected BITCOREs will FUSE into a YELLOW $PLATECORE - CLICK 'FUSE YELLOW $PLATECORE NFT'");
        newFuseColour = "YELLOW";
      } else {
        window.alert("Your 4 selected BITCOREs do not make a valid colour to FUSE into a $PLATECORE - PLEASE TRY A DIFFERENT COMBINATION");
      }

      if (newFuseColour != "") {
        setFusePLATECOREButton("FUSE " + newFuseColour + " $PLATECORE NFT");
        setnewFuseCoreColour(newCoreColour);
        setnewFuseCoreColourCode(newColour);
        setnewFuseCoreColourText(newFuseColour);
      }

    } else {
      setFusePLATECOREButton("SELECT 4 BITCOREs TO FUSE $PLATECORE NFT");
      setnewFuseCoreColour(0);
      setnewFuseCoreColourCode(0);
      setnewFuseCoreColourText('');
    }

    setTotalSelected(newTotalSelected);

  }
  
  if (loading) return (
    <main style={{ padding: "1rem 0" }}>
       <h2>FUSE PLATE CORE NFT Loading BITCOREs...</h2>
    </main>
  )
    
  return (
    <>
      <div className="flex justify-center">
      {items.length > 0 ?
        <div className="px-5 container">
          <h2>FUSE PLATE CORE NFT with Account {typeof account === 'undefined'
          ? ''
          : account
          ? `${account.substring(0, 6)}...${account.substring(
              account.length - 4
            )}`
          : ''} BITCOREs</h2>
           <div>&nbsp;</div>
            <Row className="g-4">
            <Col>
            </Col>
            <Col>
            <div className="d-grid px-8">
              <Button onClick={handleFusePlatecoreNFT} variant="primary" size="lg">
                {fusePLATECOREButton}
              </Button>
            </div>
            </Col>
            <Col>
            </Col>
            </Row>
         
          <Form>
          <Row xs={1} md={2} lg={6} className="g-7 py-5">
            {items.map((item, idx) => (
              <Col key={idx}  className=" text-center py-0">
                <Card style={{ background: "#000000", border: "2px solid #41464b" }}>
                  <Card.Body>
                    <Card.Img variant="top" src={item.image} />
                    <Form.Check 
                      onChange={(e) => handleSelectChange(e, item)}
                      type="switch"
                      id={item.itemId}
                      label="Select"
                    />
                    </Card.Body>
                  <Card.Footer style={{ background: "#212529", borderTop: "2px solid #41464b", padding: "0.2rem 0.2rem" }}>
                  <Card.Text>
                    <h6>#{item.itemId} {item.description} </h6>
                  </Card.Text>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
          </Form>
        </div>
        : (
          <main style={{ padding: "1rem 0" }}>
            <h2>No BITCOREs</h2>
          </main>
        )}
    </div>
    </>
  );
}
